
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcUserButton as ObcUserButtonElement} from '@oicl/openbridge-webcomponents/dist/components/user-button/user-button.js';
 
 
 

 
 export const ObcUserButton = createComponent({
   react: React,
   tagName: 'obc-user-button',
   elementClass: ObcUserButtonElement,
   events: {
     
   }
  });
 
 